"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _ContentDelivery = _interopRequireDefault(require("../ContentDelivery"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var ImagePreloader =
/*#__PURE__*/
function () {
  function ImagePreloader() {
    _classCallCheck(this, ImagePreloader);
  }

  _createClass(ImagePreloader, [{
    key: "preload",
    value: function preload(urls) {
      var _this = this;

      return Promise.all(urls.map(function (url) {
        return _this.loadImageBlob(url);
      })).then(function (urls) {
        return urls.reduce(function (acc, cur) {
          acc[cur.key] = cur.value;
          return acc;
        }, {});
      });
    }
    /**
     * Loads image blob from specified URL and returns http URL => blob URL mapping
     *
     * @param {String} src
     * @returns {Promise}
     */

  }, {
    key: "loadImageBlob",
    value: function loadImageBlob(src) {
      var source = _axios.default.CancelToken.source(); // generate cancellation token


      var promise = _ContentDelivery.default.get({
        url: src,
        responseType: 'blob',
        cancelToken: source.token
      });

      promise.cancel = function (msg) {
        source.cancel(msg);
      };

      return promise.then(function (response) {
        return response.data;
      }).then(function (blob) {
        return URL.createObjectURL(blob);
      }).then(function (blobUrl) {
        return {
          key: src,
          value: blobUrl
        };
      });
    }
  }]);

  return ImagePreloader;
}();

var _default = new ImagePreloader();

exports.default = _default;